import { render, staticRenderFns } from "./PausedAccountBanner.vue?vue&type=template&id=3f8f2561&"
import script from "./PausedAccountBanner.vue?vue&type=script&lang=ts&"
export * from "./PausedAccountBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports